var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-alert',{staticClass:"alertSytle",attrs:{"type":_vm.alert.alertType,"value":_vm.alert.showAlert,"transition":"scale-transition"}},[_vm._v(_vm._s(_vm.alert.message))]),_c('Loader'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }